// extracted by mini-css-extract-plugin
module.exports = {"wrFreelance":"WrFreelance_wrFreelance__3W1yx","container":"WrFreelance_container__3YeLx"};